import { render, staticRenderFns } from "./casePublicity.vue?vue&type=template&id=24dcbe6e&scoped=true"
import script from "./casePublicity.vue?vue&type=script&lang=js"
export * from "./casePublicity.vue?vue&type=script&lang=js"
import style0 from "./casePublicity.vue?vue&type=style&index=0&id=24dcbe6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcbe6e",
  null
  
)

export default component.exports